// Client-Side IDs are not secret
// https://docs.launchdarkly.com/sdk/client-side/react/react-web#getting-started
/* LaunchDarkly Configs */
let clientSideId;

/* Autodesk Assistant Configs */
let autoAssistantClientId: string | undefined;
let autodeskAssistantEnvironment: "dev" | "stg" | "prd" | undefined;

switch (window.location.hostname) {
  case "forge.autodesk.com":
    clientSideId = "620d9f16f72c7914c61de4c1";
    autoAssistantClientId = "6n9USGcTDsFWehpFdiXO2O9SRLB3Pu6AtRMWANmoREsbO6pb";
    autodeskAssistantEnvironment = "prd";
    break;
  case "aps.autodesk.com":
    clientSideId = "620d9f16f72c7914c61de4c1";
    autoAssistantClientId = "6n9USGcTDsFWehpFdiXO2O9SRLB3Pu6AtRMWANmoREsbO6pb";
    autodeskAssistantEnvironment = "prd";
    break;
  case "stg.forge.autodesk.com":
    clientSideId = "620d9f18c9f56d1487a0c804";
    autoAssistantClientId = "ulK5ZeKaAnkPF19tigZvVA0nQQ3pegDlMzrAvfBosOKpmJWG";
    autodeskAssistantEnvironment = "stg";
    break;
  case "aps-stg.autodesk.com":
    clientSideId = "620d9f18c9f56d1487a0c804";
    autoAssistantClientId = "ulK5ZeKaAnkPF19tigZvVA0nQQ3pegDlMzrAvfBosOKpmJWG";
    autodeskAssistantEnvironment = "stg";
    break;
  case "aps.autodesk.us":
    clientSideId = "69ccac3ca985460be3d72b66";
    break;
  case "aps.stg.autodesk.us":
    clientSideId = "69ccac1dcb5a6d0bb02c580a";
    break;
  // Local development deliberately uses the *staging* Autodesk Assistant rather than
  // dev. The assistant's env is picked here from the hostname, while the Django env is
  // picked independently by DJANGO_SETTINGS_MODULE (see utility-scripts/toggle-envs.sh),
  // and both local modes share this hostname — so the hostname cannot tell them apart.
  // Staging is the only assistant environment known to work: the dev ADP app rejects
  // the consent request (401 from adppa-dev /config/v1/pups), so pointing local at dev
  // means the assistant silently never opens.
  //
  // NOTE: the staging assistant client must have the local callback URL
  // (`<origin>/myaccount/pkce-unauthenticated-redirect/`) registered, or the PKCE
  // redirect fails with invalid_redirect_uri.
  case "developer-local.autodesk.com":
  case "local.forge.autodesk.com":
    clientSideId = "620d9f19d8e9ea0bb4c36ce0";
    autoAssistantClientId = "ulK5ZeKaAnkPF19tigZvVA0nQQ3pegDlMzrAvfBosOKpmJWG";
    autodeskAssistantEnvironment = "stg";
    break;
  default:
    clientSideId = "620d9f19d8e9ea0bb4c36ce0";
    autoAssistantClientId = "uVAWwGtJWJCBMnwECxhlRDU5hOH8Bcdm4iiCd3sIBL2X1XOI";
    autodeskAssistantEnvironment = "dev";
    break;
}

export const launchDarklyClientSideID = clientSideId;

export const autodeskAssistantClientId = autoAssistantClientId;

export const environment = autodeskAssistantEnvironment;

export const hasRequiredAssistantInfo =
  autoAssistantClientId !== undefined &&
  autodeskAssistantEnvironment !== undefined;
